// extracted by mini-css-extract-plugin
module.exports = {"desktop_nav":"NavItems-module--desktop_nav--gyDdF"};